import { render } from "./add-sales.vue?vue&type=template&id=b514d5ca&scoped=true"
import script from "./add-sales.vue?vue&type=script&lang=js"
export * from "./add-sales.vue?vue&type=script&lang=js"

import "./add-sales.vue?vue&type=style&index=0&id=b514d5ca&scoped=true&lang=css"
import "./add-sales.vue?vue&type=style&index=1&id=b514d5ca&lang=css"

import exportComponent from "C:\\actions-runner\\_work\\cims-billing.ui\\cims-billing.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b514d5ca"]])

export default __exports__